import "@/App.css";
import {
  ROUTE_ADMIN_MANAGEMENT,
  ROUTE_HOME,
  ROUTE_ITEM,
  ROUTE_LOGGING_IN,
  ROUTE_LOGIN_OUT,
  ROUTE_MERGE_COMPANIES,
  ROUTE_ORDER_MANAGEMENT,
  ROUTE_PRICING_LEAD_TIME_ESTIMATION,
  ROUTE_PROFILE,
  ROUTE_QUOTATION_MANAGEMENT,
  ROUTE_REPORTS_LIST,
  ROUTE_USER_MANAGEMENT,
} from "@/constants/routes.constants";
import PageAdminManagement from "@/pages/AdminManagement/adminManagement.page";
import PageDashboard from "@/pages/Dashboard/dashboard.page";
import PageItem from "@/pages/Item/item.page";
import PageLeads from "@/pages/Leads/leads.page";
import PageLoggingIn from "@/pages/LoggingIn/loggingIn.page";
import PageLogin from "@/pages/Login/login.page";
import PageMergeCompanies from "@/pages/MergeCompanies/mergeCompanies.page";
import PageNotFound from "@/pages/NotFound/notfound.page";
import PageOrderTracking from "@/pages/OrderTracking/orderTracking.page";
import PageProfile from "@/pages/Profile/profile.page";
import PageQuotation from "@/pages/Quotation/quotation.page";
import PageReportsList from "@/pages/ReportsList/reportsList.page";
import PageUserManagement from "@/pages/UserManagement/userManagement.page";
import { NetworkStatusProvider } from "@/services/NetworkContext/networkStatusProvider";
import ProtectedRoute from "@/services/ProtectedRoute";
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router";

function App() {
  return (
    <div className={`App h-svh w-svw overflow-hidden`}>
      <NetworkStatusProvider>
        <Router>
          <Routes>
            <Route path={ROUTE_LOGIN_OUT} element={<PageLogin />} />
            <Route path={ROUTE_LOGGING_IN} element={<PageLoggingIn />} />
            <Route element={<ProtectedRoute />}>
              <Route path={ROUTE_HOME} element={<PageDashboard />} />
              <Route
                path={ROUTE_USER_MANAGEMENT}
                element={<PageUserManagement />}
              />
              <Route
                path={ROUTE_ADMIN_MANAGEMENT}
                element={<PageAdminManagement />}
              />
              <Route path={`${ROUTE_ITEM}/:itemID`} element={<PageItem />} />
              <Route
                path={ROUTE_QUOTATION_MANAGEMENT}
                element={<PageQuotation />}
              />
              <Route
                path={ROUTE_PRICING_LEAD_TIME_ESTIMATION}
                element={<PageLeads />}
              />
              <Route
                path={ROUTE_ORDER_MANAGEMENT}
                element={<PageOrderTracking />}
              />
              <Route path={ROUTE_REPORTS_LIST} element={<PageReportsList />} />
              <Route path={ROUTE_PROFILE} element={<PageProfile />} />
              <Route
                path={ROUTE_MERGE_COMPANIES}
                element={<PageMergeCompanies />}
              />
              <Route path="*" element={<PageNotFound />} />
            </Route>
            <Route path="/" element={<Navigate to={ROUTE_HOME} replace />} />
          </Routes>
        </Router>
      </NetworkStatusProvider>
    </div>
  );
}

export default App;
